import React from 'react'
import { cn, getUserType } from '@utils/safeTs'
import styles from './FlussoPersonalizzazioneOrdine.module.sass'
import { OrdineType, RootStateType } from '@utils/types'
import { useSelector } from 'react-redux'
import useTrans from '@hooks/useTrans'
import FlussoPersonalizzazionePersonalizzazione from '../FlussoPersonalizzazionePersonalizzazione/FlussoPersonalizzazionePersonalizzazione'


interface Props {
  ordine?: OrdineType
  ordini?: OrdineType[]
  children?: React.ReactNode
  className?: string
}

const FlussoPersonalizzazioneOrdine = (props: Props) => {

  const { 
    ordine,
    ordini = [],
    children,
    className = '',
  } = props

  const t = useTrans()
  const { utente } = useSelector((state: RootStateType) => state.utente)
  const userType = getUserType(utente)

  return (
    <div className={cn(styles.root, className)}>
      {/* {ordini.length > 1 && (
        <div className={styles.head}>
          <div>
            <h2 className={styles.title}>{t("Protocollo n°{0}", [ordine.numeroProtocollo])}</h2>
            {userType !== 'fornitore' && (
              <p className={cn(styles.fornitore, ordine.fornitore?.id ? '' : styles['fornitore--empty'])}>{ordine.fornitore?.id ? ordine.fornitore.ragioneSociale : t("Fornitore non assegnato")}</p>
            )}
          </div>
          <StatoOrdine stato={ordine.statoOrdineCalcolato} level='ordine' />
        </div>
      )} */}
      {children}
    </div>
  )
}

export default FlussoPersonalizzazioneOrdine
